"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeChecksum = void 0;
var sha1_1 = __importDefault(require("crypto-js/sha1"));
var DELIM = '|';
var stringify = function (obj) {
    if (obj === undefined) {
        return '';
    }
    if (Array.isArray(obj)) {
        var stringifiedArr = [];
        for (var i = 0; i < obj.length; i++) {
            stringifiedArr[i] = stringify(obj[i]);
        }
        return JSON.stringify(stringifiedArr);
    }
    if (typeof obj === 'object' && obj !== null) {
        var acc = [];
        var sortedKeys = Object.keys(obj)
            .filter(function (k) { return obj[k] !== undefined; })
            .sort();
        for (var i = 0; i < sortedKeys.length; i++) {
            var k = sortedKeys[i];
            acc[i] = k + ":" + stringify(obj[k]);
        }
        return acc.join(DELIM);
    }
    return obj;
};
var digest = function (obj) { return sha1_1.default(stringify(obj)).toString(); };
var computeChecksum = function (_a) {
    var characters = _a.characters, spells = _a.spells, time = _a.time;
    return digest({ characters: characters, spells: spells, time: time });
};
exports.computeChecksum = computeChecksum;
